export default __webpack_public_path__ + "static/media/va2003.9be785cd.jpg";